import { SystemMessage } from 'components/Dialogue';
import { BaseSysMsgProps } from './types';
import { memo } from 'react';
import { useTranslate } from '@tolgee/react';
import { formatNumber } from 'utils/numberFormat';
import { openExternalURL } from 'utils/openExternalURL';

const TITLE_MARKER = '##TITLE##';

export const JlSystemMsg = memo((props: BaseSysMsgProps) => {
  const { raw } = props;
  const { t } = useTranslate();
  const { jlSystemMsgContent } = raw;
  const { systemMsgType, sysCheckoutOrder, sysAddCart } = jlSystemMsgContent || {};

  if (systemMsgType === 'CHECKOUT_ORDER' && sysCheckoutOrder) {
    const { orderId, amount, currencyCode } = sysCheckoutOrder;
    return (
      <SystemMessage>
        {t('scene.chatWorkspace.messageThread.systemMessage.checkoutOrder', {
          orderId,
          amount,
          currencyCode,
        })}
      </SystemMessage>
    );
  }

  if (systemMsgType === 'ADD_CART' && sysAddCart) {
    const { title, url, amount, currencyCode } = sysAddCart;
    const text = t('scene.chatWorkspace.messageThread.systemMessage.addCart', {
      title: TITLE_MARKER,
      amount: formatNumber(amount, '0,0.00'),
      currencyCode,
    });
    const [prefix, suffix] = text.split(TITLE_MARKER);

    return (
      <SystemMessage>
        <div className="flex items-center">
          {prefix}
          <span
            className="px-1 inline-block max-w-[200px] truncate cursor-pointer underline text-[var(--main-color)] hover:opacity-80"
            title={title}
            onClick={() => openExternalURL(url, '_blank')}
          >
            {title}
          </span>
          {suffix}
        </div>
      </SystemMessage>
    );
  }

  return null;
});
